import React from "react";

export const ScotiamanAvatar = () => {
  return (
    <img
      alt="scotiaman-avatar"
      className="coachView__coachman__avatar"
      src={`https://scotiabankfiles.azureedge.net/scotiabank-chile/avatar1.png`}
    />
  );
};
